import React from "react";
import ChartGoal from "charts/ChartGoal";
import ChartLine from "charts/ChartLine";
import BlueIndentedSection from "dashboards/BlueIndentedSection";
import KPIMetricBlock from "dashboards/KPIMetricBlock";
import MetricFormatter from "dashboards/MetricFormatter";
import KeywordBlock from "dashboards/KeywordBlock";
import KeywordTable from "dashboards/KeywordTable";
import MetricTable from "MetricTable";
import ServiceDisabled from "dashboards/ServiceDisabled";
import NoData from "dashboards/NoData";
import jsDig from "utils/jsDig";
import getNegative from "utils/getNegative";
import GetFormatter from "dashboards/GetFormatter";
import allMetrics from "data/allMetrics.js";
import KeywordImprovedDeclinedBlock from "dashboards/KeywordImprovedDeclinedBlock";
import DashboardSubheader from "dashboards/DashboardSubheader";
import getGoalLocked from "utils/getGoalLocked";
import dismissDataPullErrors from "utils/dismissDataPullErrors";
import { camelCase, capitalize, uniq } from "lodash-es";
import dashboardTableOrder from "utils/dashboardTableOrder";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

const allMetricData = allMetrics();

class SEODashboard extends React.Component {
  constructor(props) {
    super(props);
    this.setSelectedDashboard = this.setSelectedDashboard.bind(this);
    this.state = {
      selectedDashboard: 0,
      showErrors: (jsDig(["data_pull_errors"], this.props.seo) && Object.keys(jsDig(["data_pull_errors"], this.props.seo)).length > 0 && this.props.user_is_employee) ? true : false
    };
  }

  pullInProgress() {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>A data pull is in progress.</span>
          </div>
          <div className="description">
            <p>This page is not available while the data pull is in progress.</p>
            <span></span> Please check back later or
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  }

  recalcInProgress() {
    return (
      <div className="spin-shell">
        <div className="spin-container">
          <div className="spinner">
            <img src="https://marcopolo.me/static/images/loading.png" />
          </div>
          <div className="title">
            <span>Data is being recalculated.</span>
          </div>
          <div className="description">
            <p>Your data pull has completed but data is recalculating</p>
            <span>Please be patient {this.props.user ? this.props.user.first_name : "my guy"} and check back later or</span>
            <span
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => {
                location.reload();
              }}>
              {" "}
              <b>refresh </b>
            </span>
            <span>the page.</span>
          </div>
        </div>
      </div>
    );
  };

  displayErrors() {
    return (
      <div className="spin-shell">
        <div className="spin-container" style={{ height: "auto" }}>
          <div className="title text-danger">
            <span>There were errors on the last data pull</span>
          </div>
          <div className="description">
            {this.props.seo.data_pull_errors && Object.keys(this.props.seo.data_pull_errors).map((platform) => {
              const errorCounts = this.props.seo.data_pull_errors[platform].reduce((map, val) => { map[val] = (map[val] || 0) + 1; return map }, {});
              return (
                <React.Fragment key={platform}>
                  <div style={{ paddingTop: "30px" }}>
                    <h3 className="text-danger" style={{ textAlign: "left" }}>{capitalize(platform)}:</h3>
                    <ul style={{ listStyle: "none", textAlign: "left", paddingLeft: "10px" }}>
                      {uniq(this.props.seo.data_pull_errors[platform]).map((errorMessage, index) => {
                        const length = errorCounts[errorMessage];
                        return (
                          <li key={index}>- {length > 1 ? `(${length}x) ` : ' '}{errorMessage}</li>
                        )
                      })}
                    </ul>
                  </div>
                </React.Fragment>
              )
            })}
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-info mx-2"
                onClick={(e) => {
                  dismissDataPullErrors(jsDig(["id"], this.props.seo), "seo")
                  $(e.target).closest('.spin-shell').fadeOut();
                  setTimeout(() => {
                    this.setState({ showErrors: false })
                  }, 1000)
                }}>
                Dismiss
              </button>
              <a
                className="btn btn-info mx-2"
                href="/datapulse/seo-config"
                onClick={() => {
                  dismissDataPullErrors(jsDig(["id"], this.props.seo), "seo")
                }}>
                Go to configs
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }

  generateDashboardSection(section, cc_data, dashboard) {
    const metricData = allMetricData["metricData"];
    let date = this.props.date ? moment(this.props.date) : moment();
    let month = date.format("MMM");
    let year = date.year();
    if (section.metrics_data) {
      const renderArray = dashboardTableOrder("seo", Object.keys(section.metrics_data));
      switch (section.name) {
        case "goalsAndProjections":
          let goals = this.props.seo.goals;
          return (
            <>
              <Row xs={1} sm={2} md={5} className="justify-content-center">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  const current = jsDig([dashboard, metricKey, "raw"], cc_data);
                  const goal = parseFloat(jsDig([dashboard, year, month, camelCase(metricKey)], goals));
                  const projected = jsDig([dashboard, metricKey, "projected"], cc_data);
                  const negative = getNegative(section.name, metricKey, projected - goal, cc_data);
                  const goalLocked = getGoalLocked(date, metricKey, true);
                  if (metricKey) {
                    if (jsDig([dashboard, metricKey, "raw"], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey });
                        return (
                          <Col key={index}>
                            <ChartGoal
                              metricName={metricShortened}
                              current={current}
                              goal={goal}
                              projected={projected}
                              formatter={Formatter}
                              negative={negative}
                              goalLocked={goalLocked}
                              baseCurrency={this.props.seo.base_currency}
                              displayCurrency={this.props.seo.display_currency}
                            />
                          </Col>
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </Row>
            </>
          );
        case "primaryKpiCharts":
          return (
            <>
              <Row sm={1} md={2} className="justify-content-center">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  if (metricKey) {
                    if (jsDig([dashboard, "metrics_by_months", metricKey], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey, tick: true });
                        return (
                          <Col className="mb-4" key={index}>
                            <ChartLine
                              metricName={metricShortened}
                              currentYear={jsDig([dashboard, "metrics_by_months", metricKey, 0, "year"], cc_data)}
                              currentYearData={jsDig([dashboard, "metrics_by_months", metricKey, 0, "data"], cc_data)}
                              previousYear={jsDig([dashboard, "metrics_by_months", metricKey, 1, "year"], cc_data)}
                              previousYearData={jsDig([dashboard, "metrics_by_months", metricKey, 1, "data"], cc_data)}
                              tickFormatter={Formatter}
                              baseCurrency={this.props.seo.base_currency}
                              displayCurrency={this.props.seo.display_currency}
                            />
                          </Col>
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in metrics_by_month in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </Row>
            </>
          );
        case "primaryKpiTables":
          let metricTitles = [];
          return (
            <>
              <Row sm={1} className="justify-content-center">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  if (metricKey) {
                    metricTitles.push(metricKey);
                    if (jsDig([dashboard, "metrics_2_years", metricKey], cc_data) == null) {
                      return (
                        <p className="text-danger" key={index}>
                          {metricKey} was not found in metrics_2_years in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
                <Col className="mb-4">
                  <MetricTable
                    table={jsDig([dashboard, "metrics_2_years"], cc_data)}
                    client={this.props.client_name}
                    headerOrder={metricTitles}
                    date={this.props.date}
                    scrollMessage={true}
                    responsive={true}
                    userDefaultView={jsDig(["user", "table_view_preference"], this.props)}
                    baseCurrency={this.props.seo.base_currency}
                    displayCurrency={this.props.seo.display_currency}
                  />
                </Col>
              </Row>
            </>
          );
        case "allKpisVsPreviousYear":
          return (
            <>
              <div className="metric-blocks">
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                  if (metricKey) {
                    if (jsDig([dashboard, metricKey], cc_data) != null) {
                      if (section.metrics_data[metricName] == "1") {
                        let Formatter = GetFormatter({ metricName: metricKey });
                        const negative = getNegative(section.name, metricKey, jsDig([dashboard, metricKey, "projected_yy"], cc_data));

                        return (
                          <>
                            {metricKey == "average_position" ? (
                              <OverlayTrigger
                                key={index}
                                placement={"top"}
                                delay={{ show: 200, hide: 200 }}
                                overlay={
                                  <Tooltip className="grow-tooltip" id="button-tooltip">
                                    <div className="primary">
                                      Average Position is the monthly average of all your rankings for the keywords in your campaign. For any keyword where you
                                      aren’t ranking, it will be calculated as a ranking of 100.{" "}
                                    </div>
                                  </Tooltip>
                                }>
                                <div className=" m-3 d-inline-block">
                                  <KPIMetricBlock
                                    metricName={metricShortened}
                                    metric={<Formatter value={jsDig([dashboard, metricKey, "projected"], cc_data)} />}
                                    yy={<MetricFormatter.YY value={jsDig([dashboard, metricKey, "projected_yy"], cc_data)} />}
                                    negative={negative}
                                    key={index}
                                  />
                                </div>
                              </OverlayTrigger>
                            ) : (
                              <KPIMetricBlock
                                metricName={metricShortened}
                                metric={<Formatter value={jsDig([dashboard, metricKey, "projected"], cc_data)} baseCurrency={this.props.seo.base_currency} displayCurrency={this.props.seo.display_currency} />}
                                yy={<MetricFormatter.YY value={jsDig([dashboard, metricKey, "projected_yy"], cc_data)} />}
                                negative={negative}
                                key={index}
                              />
                            )}
                          </>
                        );
                      }
                    } else {
                      return (
                        <p className="text-danger d-inline-block" key={index}>
                          {metricKey} was not found in cc_data
                        </p>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger d-inline-block" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </div>
            </>
          );
        case "landingPageBreakdown":
          const groupOrder = this.props.seo.landing_page_group_order ? this.props.seo.landing_page_group_order : [];
          return (
            <>
              {groupOrder.map((group_id, index) => {
                let metricTitles = [];
                const landingPageGroup = this.props.seo.landing_page_groups.find((group) => group.id == group_id);
                return (
                  <Row sm={1} className="justify-content-center" key={index}>
                    <h4 className="text-center mt-4">{landingPageGroup.name}</h4>
                    {renderArray.map((metricName, index) => {
                      const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                      if (metricKey) {
                        // metricTitles.push(metricKey);
                        if (jsDig([group_id, "metrics_2_years", metricKey], cc_data) == null) {
                          return <div key={index}></div>;
                        } else {
                          metricTitles.push(metricKey);
                        }
                      } else {
                        return (
                          <p className="text-danger" key={index}>
                            {metricName} not defined in metricData.json
                          </p>
                        );
                      }
                    })}

                    <Col className="mb-4">
                      <MetricTable
                        table={jsDig([group_id, "metrics_2_years"], cc_data)}
                        client={this.props.client_name}
                        headerOrder={metricTitles}
                        date={this.props.date}
                        scrollMessage={true}
                        responsive={true}
                        userDefaultView={jsDig(["user", "table_view_preference"], this.props)}
                        baseCurrency={this.props.seo.base_currency}
                        displayCurrency={this.props.seo.display_currency}
                      />
                    </Col>
                  </Row>
                );
              })}
            </>
          );
        case "backlinks":
          return (
            <div className="metric-blocks">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                if (metricKey) {
                  if (jsDig([dashboard, metricKey], cc_data) != null) {
                    if (section.metrics_data[metricName] == "1") {
                      let Formatter = GetFormatter({ metricName: metricKey });
                      const negative = getNegative(section.name, metricKey, jsDig([dashboard, metricKey, "projected_yy"], cc_data));

                      return (
                        <KPIMetricBlock
                          metricName={metricShortened}
                          metric={<Formatter value={jsDig([dashboard, metricKey, "projected"], cc_data)} />}
                          yy={<MetricFormatter.YY value={jsDig([dashboard, metricKey, "projected_yy"], cc_data)} />}
                          negative={negative}
                          key={index}
                        />
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger d-inline-block" key={index}>
                        {metricKey} was not found in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger d-inline-block" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}
            </div>
          );
        case "keywordGroups":
          const keywordGroupOrder = this.props.seo.keyword_groups_order ? this.props.seo.keyword_groups_order : [];
          return (
            <>
              {keywordGroupOrder.map((group_id, index) => {
                // let metricTitles = jsDig([group_id, "metrics_2_years"], this.props.seo) ? Object.keys(jsDig([group_id, "metrics_2_years"], cc_data)) : [];
                const keywordGroup = this.props.seo.keyword_groups.find((group) => group.id == group_id);
                console.log(keywordGroup)
                let metricTitle = this.props.seo.keyword_groups.map((group) => group.name)[index];
                let metricTitles = [];
                metricTitles.push(metricTitle);
                return (
                  <div key={index}>
                    <Row sm={1} className="justify-content-center">
                      <h4 className="text-center mt-4">{keywordGroup ? keywordGroup.name : ""}</h4>
                      {renderArray.map((metricName, index) => {
                        const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                        if (metricKey) {
                          if (jsDig([0, "metrics_2_years", metricKey], cc_data) == null) {
                            return (
                              <p className="text-danger" key={index}>
                                {metricKey} was not found in metrics_2_years in cc_data for landing page group {group_id}
                              </p>
                            );
                          }
                        } else {
                          return (
                            <p className="text-danger" key={index}>
                              {metricName} not defined in metricData.json
                            </p>
                          );
                        }
                      })}

                      <Col className="mb-4">
                        <MetricTable
                          table={jsDig([0, "keyword_traffic", group_id], cc_data)}
                          client={this.props.client_name}
                          headerOrder={["traffic"]}
                          date={this.props.date}
                          scrollMessage={true}
                          responsive={true}
                          userDefaultView={jsDig(["user", "table_view_preference"], this.props)}
                          baseCurrency={this.props.seo.base_currency}
                          displayCurrency={this.props.seo.display_currency}
                        />
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </>
          );
        case "keywordSummary":
          return (
            <>
              <Row xs={1} sm={2} md={3} lg={4} className="justify-content-left">
                <Col>
                  <KeywordBlock
                    metricName="Top 3"
                    metric={jsDig([dashboard, "top_three_keywords", "raw"], cc_data)}
                    yy={jsDig([dashboard, "top_three_keywords_percentage", "raw"], cc_data)}
                  />
                </Col>
                <Col>
                  <KeywordBlock
                    metricName="Top 10"
                    metric={jsDig([dashboard, "top_ten_keywords", "raw"], cc_data)}
                    yy={jsDig([dashboard, "top_ten_keywords_percentage", "raw"], cc_data)}
                    new={0}
                    lost={0}
                  />
                </Col>
                <Col>
                  <KeywordBlock
                    metricName="Top 20"
                    metric={jsDig([dashboard, "top_twenty_keywords", "raw"], cc_data)}
                    yy={jsDig([dashboard, "top_twenty_keywords_percentage", "raw"], cc_data)}
                    new={0}
                    lost={0}
                  />
                </Col>
                <Col>
                  <KeywordImprovedDeclinedBlock
                    improved={jsDig([dashboard, "keywords_improved", "raw"], cc_data)}
                    declined={jsDig([dashboard, "keywords_declined", "raw"], cc_data)}
                  />
                </Col>
              </Row>
            </>
          );
        case "keywordRankings":
          return (
            <Row>
              <Col>
                <KeywordTable
                  keywords={jsDig([dashboard, "keyword_rankings"], cc_data)}
                  metrics={jsDig(["dashboard_order", dashboard], this.props.seo).find((el) => el.name == "keywordRankings")}
                  keyword_sort_order_asc={this.props.keyword_sort_order_asc}
                  keyword_sort={this.props.keyword_sort}
                  user_is_employee={this.props.user_is_employee}
                />
              </Col>
            </Row>
          );

        default:
          return (
            <>
              <h4 className="text-danger">{section.name} is not a valid section name for this dashboard</h4>
            </>
          );
      }
    }
  }
  setSelectedDashboard(id) {
    this.setState({ selectedDashboard: id });
  }

  render() {
    const dashboard = this.state.selectedDashboard;
    let cc_data = this.props.cc_data;

    const dashboards = [{ name: "SEO: Overall", id: 0 }, ...this.props.seo.landing_page_groups.map((group) => ({ name: group.name, id: group.id }))];
    const sectionList = jsDig(["metricsByDashboard", "seo", "sections"], allMetricData);
    const defaultMetrics = jsDig(["metricsByDashboard", "seo", "defaults", this.props.client_type], allMetricData);
    let dashboardsEnable = false;
    const seoPulling =
      (jsDig(["data_pull_status", "google_data_pull"], this.props.seo) && jsDig(["data_pull_status", "google_data_pull"], this.props.seo).length > 0) ||
      (jsDig(["data_pull_status", "search_console_data_pull"], this.props.seo) && jsDig(["data_pull_status", "search_console_data_pull"], this.props.seo).length > 0) ||
      (jsDig(["data_pull_status", "semrush_data_pull"], this.props.seo) && jsDig(["data_pull_status", "semrush_data_pull"], this.props.seo).length > 0);

    const seoRecalculating = (jsDig(["data_pull_status", "recalculation"], this.props.seo) && jsDig(["data_pull_status", "recalculation"], this.props.seo).length > 0)

    let dashboardOrder =
      jsDig([dashboard], this.props.seo.dashboard_order) && jsDig([dashboard], this.props.seo.dashboard_order).length > 0
        ? jsDig([dashboard], this.props.seo.dashboard_order)
        : Object.keys(sectionList).map((sectionName) => {
          return {
            name: sectionName,
            enabled: true,
            metrics_data: Object.keys(defaultMetrics[sectionName]).reduce((sum, item) => {
              sum[item] = "1";
              return sum;
            }, {}),
          };
        });

    if (this.props.enabled) {
      if (jsDig([this.state.selectedDashboard, "date"], cc_data)) {
        return (
          <>
            <DashboardSubheader
              seo={this.props.seo.landing_page_groups ? this.props.seo.landing_page_groups : undefined}
              dashboards={dashboards}
              selectedDashboard={this.state.selectedDashboard}
              setSelectedDashboard={this.setSelectedDashboard}
            />

            {seoPulling ? (
              this.pullInProgress()
            ) : seoRecalculating ? (
              this.recalcInProgress()
            ) : this.state.showErrors ? (
              this.displayErrors()
            ) : (
              <>
                {dashboardOrder.map((dashboardSection, index) => {
                  const sectionData = sectionList[dashboardSection.name];
                  if (dashboardSection.enabled) {
                    dashboardsEnable = true;
                    return (
                      <BlueIndentedSection key={index} ppcDash={true} sectionTitle={sectionData.name.title}>
                        {this.generateDashboardSection(dashboardSection, cc_data, this.state.selectedDashboard)}
                      </BlueIndentedSection>
                    );
                  }
                })}
                {!dashboardsEnable &&
                  (this.props.user_is_employee ? (
                    <p>You have not enabled any sections for this dashboard yet. Click the configure dashboard button above to set up your dashboard.</p>
                  ) : (
                    <p>No sections of this dashboard are currently enabled. Please contact your account representatives if you would like to this view.</p>
                  ))}
              </>
            )}
          </>
        );
      } else {
        return (
          <>
            <DashboardSubheader
              seo={this.props.seo.landing_page_groups ? this.props.seo.landing_page_groups : undefined}
              dashboards={dashboards}
              selectedDashboard={this.selectedDashboard}
              setSelectedDashboard={this.setSelectedDashboard}
            />
            <NoData service="seo" />
          </>
        );
      }
    } else {
      return <ServiceDisabled service="seo" organizationName={this.props.organization_name} userIsEmployee={this.props.user_is_employee} />;
    }
  }
}

export default SEODashboard;
